<div class="rounded-2xl shadow-md p-6 bg-white dark:bg-surface-800 grid grid-cols-[1fr_auto] gap-6 w-full h-full transition-all md:flex md:flex-row md:justify-between md:items-start md:flex-nowrap">
    <!-- FILA 1 (mobile): Saludo ocupa todo -->
    <!-- En desktop se muestra con el avatar a la izquierda (md:block del avatar desktop) -->
    <div class="col-span-2 order-1 md:order-1 min-w-0 md:flex md:items-center md:gap-4">
        <!-- Avatar DESKTOP (a la izquierda del saludo en md+) -->
        <div class="hidden md:block">
            <div class="relative avatar-wrap" [ngClass]="shineOnceClass" aria-hidden="true">
                <div class="avatar">
                    @if (avatarUrl) {
                        <img [src]="avatarUrl" [alt]="displayFormattedName" class="avatar-img" width="112" height="112" decoding="async" />
                    } @else {
                            <div class="avatar-fallback" role="img" aria-label="Avatar genérico">
                                <i class="pi pi-user avatar-placeholder-icon" aria-hidden="true"></i>
                                <span class="sr-only">{{ displayFormattedName }}</span>
                            </div>
                    }
                </div>
                <span class="shine"></span>
            </div>
        </div>

        <!-- Texto del saludo -->
        <div class="flex flex-col min-w-0">
            <div class="flex items-center gap-2 min-w-0 flex-wrap">
                <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-100 leading-tight break-words min-w-0 flex-1">{{ greeting }}, {{ displayFormattedName }}!</h2>
                <span class="text-3xl leading-none shrink-0 mt-1 md:mt-0">☕</span>
            </div>
            <p class="mt-1 text-sm italic text-surface-400 dark:text-surface-400">Esperamos que tenga un gran día de trabajo.</p>
        </div>
    </div>

    <!-- COLUMNA IZQ (mobile): Info -->
    <div class="order-2 md:order-3 flex flex-col gap-1 text-sm text-surface-500 dark:text-surface-300 min-w-0">
        <div class="flex items-center gap-2">
            <i class="pi pi-calendar text-primary-500"></i>
            <span
                ><strong>{{ todayFormatted }}</strong></span
            >
        </div>
        <div class="flex items-center gap-2">
            <i class="pi pi-map-marker text-primary-500"></i>
            <span
                >Estás en <strong>{{ city }}</strong></span
            >
        </div>
        <div class="flex items-center gap-2">
            <i class="pi pi-sun text-primary-500"></i>
            <span
                >Temperatura: <strong>{{ temperature }}°C</strong></span
            >
        </div>
    </div>

    <!-- COLUMNA DER (mobile): Avatar a la derecha de la info -->
    <div class="order-3 md:order-0 justify-self-end self-start md:hidden">
        <div class="relative avatar-wrap" [ngClass]="shineOnceClass" aria-hidden="true">
            <div class="avatar avatar--sm">
                @if (avatarUrl) {
                    <img [src]="avatarUrl" [alt]="displayFormattedName" class="avatar-img" width="96" height="96" decoding="async" />
                } @else {
                    <div class="avatar-fallback" role="img" aria-label="Avatar genérico">
                        <i class="pi pi-user avatar-placeholder-icon" aria-hidden="true"></i>
                        <span class="sr-only">{{ displayFormattedName }}</span>
                    </div>
                }
            </div>
            <span class="shine"></span>
        </div>
    </div>
</div>
